<template>
  <div class="container">
    <div class="searchBox">
      <div class="left">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="ID/商品名称/款号" v-model="formObj.fuzzyQuery" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- <div class="right">
                <el-button>下载列表</el-button>
      </div>-->
    </div>
    <div class="tableBox">
      <el-table v-loading="isLoading" :data="tableData" size="small">
        <el-table-column
            align="center"
            label="序号"
            type="index"
            width="80"
            :index="indexMethod"
        >
        </el-table-column>
        <el-table-column  prop="order_number" label="账单订单号" >        </el-table-column>
        <el-table-column  prop="finalOrderNumber" label="下单/清算订单号" >        </el-table-column>
        <el-table-column label="图片">
            <template slot-scope="scope">
                <el-image
                    style="width: 64px; height: 64px"
                    :src="scope.row.productMainImageFile"
                    fit="cover"
                >
                </el-image>
            </template>
        </el-table-column>
        <el-table-column  prop="productName" label="商品名" >        </el-table-column>
        <el-table-column  prop="styleNumber" label="款号" >        </el-table-column>
        <el-table-column  prop="item_order_price" label="下单价格" >
          <template slot-scope="scope">
           ¥ {{scope.row.item_order_price}}元/件
          </template>
        </el-table-column>
        <el-table-column  prop="order_state" label="订单状态" >
          <template slot-scope="scope">
            <span :class="{green:scope.row.order_state==3,red:scope.row.order_state==1,orange_lighter:scope.row.order_state==2}">
              {{turnOrderState[scope.row.order_state]}}
            </span>

          </template>
        </el-table-column>
        <el-table-column  prop="order_type" label="账单类型" >
            <template slot-scope="scope">
              {{turnOrderType[scope.row.order_type]}}
            </template>
        </el-table-column>
        <!-- order_type/1是销售商付款的,2是下单平台结款的，3是清算 销售商付款的,4是清算平台结款的 -->
        <el-table-column  prop="order_submit_time" label="下单时间" >        </el-table-column>
        <el-table-column  prop="purchaseOrderQuantity" label="下单数" >
          <template slot-scope="scope">
           {{scope.row.purchaseOrderQuantity}}件
          </template>
        </el-table-column>
        <el-table-column  prop="supplierName" label="供应商" >        </el-table-column>
        <el-table-column  prop="dealerName" label="销售商" >        </el-table-column>
        <el-table-column  prop="order_bill_amount" label="账单金额" >
          <template slot-scope="scope">
           ¥ {{scope.row.order_bill_amount}}
          </template>
        </el-table-column>
        <el-table-column  prop="order_pay_amount" label="已付金额" >
          <template slot-scope="scope">
           ¥ {{scope.row.order_pay_amount}}
          </template>
        </el-table-column>
        <el-table-column
            prop=""
            label="账单周期" width="200"
        >
            <template slot-scope="scope">
                {{scope.row.bill_start_time}}(起)
                <br>
                {{scope.row.bill_end_time}}(止)
            </template>
        </el-table-column>
      <!--  <el-table-column
        prop="mallItemFileUrl"
        label="图片"
        width="100">
            <template slot-scope="scope">
                <el-image
                    style="width: 64px; height: 64px"
                    :src="scope.row.productMainImageFile"
                    fit="cover"
                    :preview-src-list="[scope.row.productMainImageFile]"
                >
                </el-image>
            </template>
        </el-table-column> -->
        <!-- <el-table-column
            label="操作"
            min-width="160" fixed="right"
        >
            <template slot-scope="scope">
                <el-button class="cg-icon-btn" @click="toLockDetail(scope.row)" type="text" size="small">查看</el-button>
            </template>
        </el-table-column> -->

      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="searchObj.page"
        :page-size.sync="searchObj.num"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { ajaxPost, api } from "@/common/request.js"
import { lockOrderState } from '@/common/order-state.js'
export default {
  name: "listOrder",
  data() {
    return {
      isLoading: false,
      formObj: {
        fuzzyQuery: ""
      },
      searchObj: {
        page: 1,
        num: 10
      },
      //表格
      tableData: [],
      //分页
      total: 0,
      lockState: lockOrderState,
      turnOrderType:{
        1:'下单-销售商付款',
        2:'下单-平台结款',
        3:'清算-销售商付款',
        4:'清算-平台结款',
      },
      turnOrderState:{
        1:"未付款",
        2:"部分付款",
        3:"该笔已付清"
      },
      tagType: {
        0: 'info',
        1: 'success',
        2: 'warning',
        3: 'danger',
        4: 'danger',
        5: 'success'
      }
    };
  },
  computed: {
    IMG_PREV() {
      return api.imgPrev;
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.searchObj.num = Number(this.$route.query.size)
          ? Number(this.$route.query.size)
          : 10;
        this.searchObj.page = Number(this.$route.query.page)
          ? Number(this.$route.query.page)
          : 1;
        this.formObj.fuzzyQuery = this.$route.query.search || "";
        this.getTableLists();
      },
      immediate: true
    }
  },
  components: {},
  methods: {
    indexMethod(index) {
      return (
        this.total - this.searchObj.num * (this.searchObj.page - 1) - index
      );
    },
    back() {
      this.$router.back();
    },
    toLockDetail(row) {
      this.$router.push('/bill/detail?orderNumber=' + row.order_number + '&itemId=' + row.item_id);
    },
    fuzzySearchClick() {
      this.searchObj.page = 1;
      this.updateRouter();
    },
    updateRouter() {
      this.$router
        .push(
          "/bill/list?search=" +
            this.formObj.fuzzyQuery +
            "&page=" +
            this.searchObj.page +
            "&size=" +
            this.searchObj.num
        )
    },
    getTableLists() {
      let _this = this;
      this.isLoading = true;
      ajaxPost("/dwOrder/getBillListByFuzzy", {
        supplierUserId: "",
        dealerUserId: "",
        page: this.searchObj.page,
        num: this.searchObj.num,
        fuzzyQuery: this.formObj.fuzzyQuery
      }).then(
        function(res) {
          console.log("/dwOrder/getBillListByFuzzy", res);
          _this.tableData = [];
          _this.isLoading = false;
          if (res.errorCode == 200) {
            _this.tableData = res.data.billList.map(item => {
              // item.finalOrderNumber=item.order_type

                let buffer=item
                if(buffer.order_type==1||buffer.order_type==2){
                  buffer.finalOrderNumber=buffer.purchaseOrderNo
                }else{
                  buffer.finalOrderNumber=buffer.liquidateOrderNo
                }
                return {
                    ...buffer,
                    productMainImageFile: _this.IMG_PREV + item.productMainImageFile
                }
            })
            _this.total = parseInt(res.data.totalCount)
        } else {
            _this.$message.error(res.errorMsg || '获取列表数据失败')
        }

        },
        function(res) {
          _this.isLoading = false;
        }
      );
    },
    handleSizeChange(size) {
      //分页：每页n条
      this.searchObj.num = size;
      this.searchObj.page = 1;
      this.updateRouter();
    },
    handleCurrentChange(page) {
      //分页：改变第n页
      this.searchObj.page = page;
      this.updateRouter();
    }
  },
  created() {},
  mounted() {}
};
</script>

<style scoped lang="scss">
.searchBox {
  padding: 0.25rem 0.25rem 0;
  .left {
    float: left;
  }
  .right {
    float: right;
  }
}
.searchBox:after {
  content: "";
  display: block;
  clear: both;
}
.tableBox {
  padding: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/bill/list.vue